import React, { useEffect, useState } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import {
  plantColumns,
  complexColumns
} from "../ui/helper/UI_2_1.helper";
import {
  getYesterday,
  getMonthBetween,
  getInloInfo,
  getYesterDayOfMonth,
  exportRowsToExcel
} from "../common/commonMethod";
import {
  DataGrid,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { Box } from "@mui/material";
import UI2ColumnChart from "./helper/UI2ColumnChart";
import { Button } from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';

/**
 * @description 운전현황 > 일간현황
 * @author seoeunPark
 * @date 12/12/2023
 * @param {*}
 * @return  운전현황 > 일간현황
 */

export const UI_2_1 = (props) => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo),user);

  const [rows, setRows] = useState([]);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(
    user.ugrpNo === 1021 ? complexColumns : plantColumns
  );

  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchCompanyInlo, setFetchCompanyInlo] = useState([]);  
  const [fetchPlantInlo, setFetchPlantInlo] = useState([]);
  const [pageSize, setPageSize] = useState(25);  
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  const energyOption = [
    { label: "압축공기", value: "AIR" },
    { label: "스팀", value: "STEAM" }
  ];

  const yesterday = getYesterday();
  const yesterDayOfMonth = getYesterDayOfMonth();

  const [selected, setSelected] = useState({
    engId: "AIR",
    method: "cons",    
    complexInloNo: user.ugrpNo === 1021||user.ugrpNo === 1024? inlo.complexInloNo : "",
    companyInloNo:user.ugrpNo === 1024? inlo.companyInloNo : "",
    plantInloNo: user.ugrpNo === 1024? inlo.inloNo : "",
    startDate: yesterDayOfMonth,
    endDate: yesterday
  });

  
  // 검색버튼
  const submitBtnClick = async () => {
    if (selected == null) return;

    if (parseInt(selected.startDate) > parseInt(selected.endDate)) {
      FxWindow.alert("조회 기간이 잘못되었습니다.", true);
      return;
    } else if (
      getMonthBetween(selected.startDate.replace(/-/gi, ""), selected.endDate.replace(/-/gi, "")) > 5*12
    ) {
      FxWindow.alert("최대 5년까지 조회 가능합니다.", true);
      return;
    }
    const param = {
      method : selected.method,
      engId: selected.engId,
      complexInloNo: selected.complexInloNo,
      companyInloNo: selected.companyInloNo,
      plantInloNo: selected.plantInloNo,
      startDate: selected.startDate.replace(/-/gi, ""),
      endDate: selected.endDate.replace(/-/gi, ""),
      gubun : 'day',
    }

    const uri = "vup/select_2_1";
    try {
      const res = await FxmsData.selectGridData(uri, param);
      let index = 0;
      for (let data of res.data) {
        data.id = index++;
      }
      FxWindow.alert(res.data.length + " 건의 데이터가 조회되었습니다.");
    
      setData(res.data);
      let response = res.data;
      response.map((item, index) => {
        return { ...item, id: index };
      });

      // 그리드에 데이터
      setRows(response);
      //  제외할 키 목록
      const excludedKeys = new Set([
        "psDate",
        "method",
        "engName",
        "engId",
        "engUnit",
        "complexInloName",
        "sumAmt",
        "id",
      ]);

      let result = response.flatMap((obj) => {
        // 필터링된 키들을 담을 배열
        const filteredKeys = [];

        // 기존 객체의 모든 키를 순회합니다.
        for (let key in obj) {
          // 제외할 키가 아니라면 배열에 추가합니다.
          if (!excludedKeys.has(key)) {
            filteredKeys.push({
              field: key,
              headerName: key,
              width: 120,
              headerClassName: "DataGridHeader",
              valueFormatter: (params) => {
                // return new Intl.NumberFormat("ko-KR").format(params.value);
                return new Intl.NumberFormat("ko-KR").format(Math.round(params.value));
              },
            });
          }
        }

        return filteredKeys;
      });
      // 중복 제거
      result = Array.from(
        new Map(result.map((item) => [item.field, item])).values()
      );
      setColumns((prev) => [...complexColumns, ...result]);

    } catch (error) {
      console.log("error" + error);
      FxWindow.alert("조회중 오류가 발행되었습니다.", true);
      // setRows([]);
      setData([]);
    }
  };

  useEffect(() => {
    console.log("*** UI_2_1 ***");
  
    const initializeData = async () => {
      if(user.ugrpNo !== 1021 && user.ugrpNo !== 1024){ // 산단      
        const uri = "vup/getComplexInloList";
        try {
          const res = await FxmsData.GET(uri);
          setFetchComplexInlo(res.data);
          
          if (res.data.length > 0) {
            // selected 상태 업데이트
            setSelected(prev => ({ 
              ...prev, 
              complexInloNo: res.data[0]?.inloNo 
            }));
          }
        } catch (e) {
          console.log("getComplexInloList error ........", e);
        }
      } else {
        submitBtnClick();
      }
    };
  
    initializeData();
  }, [inlo, user]);
  
  // fetchComplexInlo가 업데이트된 후 조회하는 useEffect 추가
  useEffect(() => {
    if (fetchComplexInlo.length > 0 && user.ugrpNo === 1020) {
      // selected 상태가 업데이트된 후 조회
      setTimeout(() => {
        submitBtnClick();
      }, 100);
    }
  }, [fetchComplexInlo]);

  const selectedComplex = async (value) => {
    console.log("선택된 산단번호 ::", value);
    setSelected((prev) => ({ ...prev, complexInloNo: value }));

    if(value === "" || !value){
      setFetchCompanyInlo([]);
      setSelected((prev) => ({ ...prev, companyInloNo: "" }));
      setSelected((prev) => ({ ...prev, plantInloNo: "" }));
      setSelected((prev) => ({ ...prev, facNo: "" }));   
    } else {
      const param = {
        energy: selected.engId,
        sourceSink: selected.method ==='cons'? 'SINK':'SOURCE',
        complexInloNo: value,
      }
        const uri = "vup/getCompanyInloListNew";
      try {
        const res = await FxmsData.GET(uri,param);       
        setFetchCompanyInlo(res.data); 
        console.log("company List >>", res.data); 
      } catch (e) {
        console.log("getCompanyInloList error.... ", e);
      }
    }
    setFetchPlantInlo([]); // 산단을 변경하면 plantInlo를 초기화
    console.log("selected ........", selected);
  }

  const selectedCompany = async (value) => {
    console.log("선택된 회사번호 :: ", value);
    setSelected((prev) => ({ ...prev, companyInloNo: value }));

    if(value===""){
      setFetchPlantInlo([]);
      setSelected((prev) => ({ ...prev, plantInloNo: value }));
      setSelected((prev) => ({ ...prev, facNo: value }));        
    }else{
      const uri = "vup/getPlantInloList/" + value;
      try {
        const res = await FxmsData.GET(uri);
        setFetchPlantInlo(res.data);
        
        console.log("plant List >>", res.data);
      } catch (e) {
        console.log("getPlantInloList error.... ", e);
      }
    }     
  }

  const onChangeDatas = (event) => {
    const { value, name } = event.target;       
    
    setSelected((prev) => {
      return { ...prev, [name]: value };
    })
  }


  const CustomToolbar = () => {
    return (
      <GridToolbarContainer sx={{ float: "right" }} />
    );
  };


  const exportToExcel = () => {
    exportRowsToExcel({
      columns,
      rows,
      fileName: props.menuFullName || "tableData",
      sheetName: (props.menuFullName || "downloadData").replaceAll("/", "_"),
      excludeId: true
    });
  };

  return (
    <>
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
          <label className="FxLabelSearch"></label>
          <select className="FxSelectSearch" name="engId" value={selected.engId} onChange={onChangeDatas}>          
            {energyOption.map((item, index) => (
            <option key={index} value={item.value} name="engId">
              {item.label}
              </option>
             ))}   
          </select>
          <select className="FxSelectSearch" name="method" onChange={onChangeDatas}>           
              <option value="cons" name="method">사용</option> 
              <option value="prod" name="method">공급</option>    
          </select>
          <label className="FxLabelSearch"></label>
          {user.ugrpNo === 1021 || user.ugrpNo === 1024 ?
          <select className="FxSelectSearch" value={inlo.complexInloNo}>
           <option value={inlo.complexInloNo}> {inlo.complexInloName} </option>
           </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedComplex(e.target.value)}>
                {/* <option value="">산업단지 전체</option> */}
                {fetchComplexInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                    {item.inloName}
                  </option>
                ))}
            </select>
            }         
         <label className="FxLabelSearch"></label>  
         {user.ugrpNo === 1024 ?
          <select className="FxSelectSearch" value={inlo.companyInloNo}>
           <option value={inlo.companyInloNo}> {inlo.companyInloName} </option>
           </select>
            :
            <select className="FxSelectSearch" onChange={(e) => selectedCompany(e.target.value)}>
                <option value="">회사 전체</option>
                {fetchCompanyInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="companyInloNo">
                    {item.inloName}
                  </option>
                ))}
            </select>            }                   
          
          <label className="FxLabelSearch"></label> 
          {user.ugrpNo === 1024 ?
              <select className="FxSelectSearch" value={inlo.inloNo}>
              <option value={inlo.inloNo}> {inlo.inloName} </option>
              </select> 
              :
             <select className="FxSelectSearch" name="plantInloNo" onChange={onChangeDatas}>
              <option value="">사업장 전체</option>
              {fetchPlantInlo?.map((item) => (
                <option key={item.inloNo} value={item.inloNo} name="plantInloNo">
                  {item.inloName}
                </option>
              ))}
            </select>  
            }                
        </div>
        <div className="FxFilterRight">
          <input className="FxDate" type="date" name="startDate" value={selected.startDate} onChange={onChangeDatas} />
          <label className="FxLabelSearch">~</label>
          <input className="FxDate" type="date" name="endDate" value={selected.endDate} onChange={onChangeDatas} />
          <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick}/>
        </div>
      </div>
      <div style={{ height: "440px" }}>
        <UI2ColumnChart dataList={data} title={"일간현황 차트"} type={"DAY"} />
      </div>
      <div className="FxCrudDataGrid">
        <div className="excelDown">
          <Button onClick={exportToExcel} startIcon={<FileDownloadIcon />}>
            엑셀 다운로드
          </Button>
        </div>
        <Box className="DataGridList" sx={{ height: "430px", width: "100%" }}>
          <DataGrid
            className="DataGrid"
            cellClassName="DataGridCell"
            rowHeight={36}
            rows={rows}
            columns={columns}
            components={{ Toolbar: CustomToolbar }}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            rowsPerPageOptions={[25, 50, 100]}
          ></DataGrid>
        </Box>
      </div>
      <footer>
        <div>Virtual Utility Plant</div>
        <div>Copyright 2022 VUP All rights reserved</div>
      </footer>
    </>
  );
};
